var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/congrat.1ed36be4.png","uri@3x": __webpack_public_path__ + "static/media/congrat.e364f4ab.png","uri@2x": __webpack_public_path__ + "static/media/congrat.b70d8b23.png",
    width: 221,
    height: 220
});